import {NgModule, ModuleWithProviders, Optional, SkipSelf, Provider} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {NotificationsService} from "./notifications.service";
import {GraphqlCoreModule} from "../graphql/graphql-core.module";

@NgModule({
  providers: [
    NotificationsService,
  ],
  imports: [
    BrowserModule,
    GraphqlCoreModule,
  ],
  declarations: [
  ],
  exports: [
  ],
})

export class NotificationsModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: NotificationsModule,
      providers: [
        {provide: NotificationsService} as Provider,
      ],
    };
  }

  constructor(@Optional() @SkipSelf() parentModule: NotificationsModule) {
    if (parentModule) {
      throw new Error("NotificationsModule is already loaded. Import it in the main module only.");
    }
  }
}
